import React from 'react'

const Checkbox = ({ id, name, isChecked, onChange, disabled }) => {
    const className = 'form-check-input checkbox-primary' + ( isChecked ? ' checked' : '' )
    return (
        <input
            type="checkbox"
            className={className}
            id={id}
            name={name}
            checked={isChecked}
            onChange={onChange}
            disabled={disabled}
        />
    )
}

export default Checkbox
